import React from "react"
import { Loader2, Plus } from "lucide-react"

const LoadMore = ({ currentItems, totalItems, loading, onLoadMore }) => {
  if (currentItems <= 0 || currentItems >= totalItems) return null

  return (
    <div className="mt-10 flex flex-col items-center gap-4 border-t border-[#2A2D31]/50 pt-6">
      <p className="text-sm text-blue-100/60">
        Showing {currentItems} of {totalItems}
      </p>
      <button
        type="button"
        onClick={onLoadMore}
        disabled={loading}
        className="inline-flex min-w-40 items-center justify-center gap-2 rounded-xl border border-[#FF6B00]/40 !bg-[#FF6B00]/10 px-5 py-3 text-sm font-semibold text-[#FF9A3D] transition-all hover:border-[#FF6B00]/70 hover:!bg-[#FF6B00]/15 disabled:cursor-wait disabled:opacity-60"
      >
        {loading ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            Loading...
          </>
        ) : (
          <>
            <Plus className="h-4 w-4" />
            Load more
          </>
        )}
      </button>
    </div>
  )
}

export default LoadMore
